function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var SvgFa541AngleRightLight = function SvgFa541AngleRightLight(props) {
  return React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fal",
    "data-icon": "angle-right",
    className: "fa-5_4_1-angle-right-light_svg__svg-inline--fa fa-5_4_1-angle-right-light_svg__fa-angle-right fa-5_4_1-angle-right-light_svg__fa-w-6",
    viewBox: "0 0 192 512"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"
  }));
};

export default SvgFa541AngleRightLight;